import { HometrackSaleDisplayBy, HometrackRentalDisplayBy } from "./HometrackLayerFilters";
import { useHometrackValue } from "./useHometrackValue";

// Given a display by, returns the relevant search parameters as well as the price mode
export const filterToSaleParams: Record<
  HometrackSaleDisplayBy,
  [Parameters<typeof useHometrackValue>[0], Parameters<typeof useHometrackValue>[2]]
> = {
  IndexedCurrentValue: [{}, "VAL_ESTIMATE"],
  LastKnownValue: [{}, "VAL_LAST"],
};

export const filterToRentalParams: Record<
  HometrackRentalDisplayBy,
  [Parameters<typeof useHometrackValue>[0], Parameters<typeof useHometrackValue>[2]]
> = {
  IndexedCurrentValue: [{}, "RENT_ESTIMATE"],
  AskingRent: [{}, "RENT_ASKING"],
};
